import { useState } from 'react';
import PlanList from './PlanList';
import CreatePlan from './CreatePlan';
import EditPlan from './EditPlan';
import AssignPlan from './AssignPlan';

const Plans = () => {
  const [view, setView] = useState('list'); // list | create | edit | assign
  const [selectedPlanId, setSelectedPlanId] = useState(null);

  const handleEdit = (id) => {
    setSelectedPlanId(id);
    setView('edit');
  };

  const handleBack = () => {
    setView('list');
    setSelectedPlanId(null);
  };

  const handleAddNew = () => setView('create');
  const handleAssign = () => setView('assign');

  const renderView = () => {
    switch (view) {
      case 'create':
        return <CreatePlan onBack={handleBack} />;
      case 'edit':
        return <EditPlan planId={selectedPlanId} onBack={handleBack} />;
      case 'assign':
        return <AssignPlan onBack={handleBack} />;
      default:
        return (
          <PlanList 
            onEdit={handleEdit} 
            onAddNew={handleAddNew}
            onAssign={handleAssign}
          />
        );
    }
  };

  return (
    <div>
      {renderView()}
    </div>
  );
};

export default Plans;